export const SEGMENT_TYPE = {
  ENTRY: 'entry',
  EXIT: 'exit',

  POINT: 'point',
  STAY: 'stay',
  SERVICE: 'service',
  PRICE: 'price',

  FLIGHT: 'flight',
  CHARTERED: 'chartered',
  SCHEDULED: 'scheduled',

  ROAD: 'road',
  BOAT: 'boat', // Road subtype.
  TRAIN: 'train', // Road subtype.
  WALK: 'walk', // Road subtype.
  HELICOPTER: 'helicopter', // Road subtype.
};

export const FLIGHT_TYPES = [SEGMENT_TYPE.FLIGHT, SEGMENT_TYPE.CHARTERED, SEGMENT_TYPE.SCHEDULED];

export const ROAD_TYPES = [SEGMENT_TYPE.ROAD, SEGMENT_TYPE.BOAT, SEGMENT_TYPE.TRAIN, SEGMENT_TYPE.WALK, SEGMENT_TYPE.HELICOPTER];

export const TRANSIT_TYPES = [...FLIGHT_TYPES, ...ROAD_TYPES];
